export default __webpack_public_path__ + "static/media/affligem_background_l2.05bc33b4.jpg";